import {
  CHECKING_TOKEN_EXPIRED,
  CHOOSING_TEAMS,
  GET_DEPARTMENTS_DONE,
  GET_TEAMS_DONE,
  GET_USER_DONE,
  GETTING_DEPARTMENTS,
  GETTING_TEAMS,
  GETTING_USER,
  RESENDING_VERIFY_EMAIL,
  SENDING_FORGET_PASSWORD_LINK,
  SET_LOGIN_DATUM_DONE,
  SETTING_PASSWORD,
  UPDATING_USER,
  USER_LOGGING,
} from './constants';

export default {
  [CHECKING_TOKEN_EXPIRED](state, checking) {
    state.checkingTokenExpired = checking;
  },
  [CHOOSING_TEAMS](state, choosing) {
    state.choosingTeam = choosing;
  },
  [GET_DEPARTMENTS_DONE](state, departments) {
    state.departments = departments;
  },
  [GET_TEAMS_DONE](state, teams) {
    state.teams = teams;
  },
  [GET_USER_DONE](state, user) {
    state.user = user;
  },
  [GETTING_DEPARTMENTS](state, getting) {
    state.gettingDepartments = getting;
  },
  [GETTING_TEAMS](state, getting) {
    state.gettingTeams = getting;
  },
  [GETTING_USER](state, getting) {
    state.gettingUser = getting;
  },
  [RESENDING_VERIFY_EMAIL](state, resending) {
    state.resending = resending;
  },
  [SENDING_FORGET_PASSWORD_LINK](state, sending) {
    state.sendingForgetPwdLink = sending;
  },
  [SET_LOGIN_DATUM_DONE](state, { id, token }) {
    state.team = id;
    state.token = token;
  },
  [SETTING_PASSWORD](state, setting) {
    state.settingPassword = setting;
  },
  [UPDATING_USER](state, updating) {
    state.updatingUser = updating;
  },
  [USER_LOGGING](state, logging) {
    state.logging = logging;
  },
};
